import React, { useState } from "react";
import CustomizedAccordions from "../components/CustomAccordion";
import { TextField, Button, Box, Typography } from "@mui/material";

function SecretStuff() {
  const [isAuthorized, setIsAuthorized] = useState(false);
  const [input, setInput] = useState("");

  const secret = atob("YmFyYmFnaWFubmk="); // base64"

  const handleSubmit = (e) => {
    e.preventDefault();
    if (input.trim().toLowerCase() === secret) {
      setIsAuthorized(true);
    } else {
      alert("Parola chiave errata.");
    }
  };

  if (!isAuthorized) {
    return (
      <Box
        sx={{
          maxWidth: 400,
          mx: "auto",
          mt: 8,
          p: 3,
          border: "0px solid gray",
          borderRadius: 2,
          textAlign: "center",
          backgroundColor: "transparent",
          color: "white",
        }}
      >
        <Typography variant="h5" gutterBottom>
          Attenzione.
        </Typography>
        <Typography variant="subtitle2" gutterBottom>
          Questa sezione è veramente molto personale.
        </Typography>

        <Typography variant="body2" gutterBottom>
          Contiene situazioni delicate a cui ho assistito di persona, 
          esperienze che ho vissuto direttamente e che potrebbero impressionare alcune persone,
          o semplici pensieri che metto su carta.
        </Typography>

        <form onSubmit={handleSubmit}>
          <TextField
            variant="outlined"
            fullWidth
            value={input}
            onChange={(e) => setInput(e.target.value)}
            placeholder="password"
            sx={{
              mb: 4,
              mt:4,
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderColor: "white",
                  borderRadius:4
                },
                "&:hover fieldset": {
                  borderColor: "white",
                  borderRadius:4
                },
                "&.Mui-focused fieldset": {
                  borderColor: "white",
                },
              },
              input: { color: "white" },
              label: { color: "white" },
            }}
          />
          <Button
            variant="outlined"
            type="submit"
            sx={{
              borderColor: "rgba(103, 58, 184, 0.8)",
              borderRadius: 6,
              color: "rgba(156, 118, 222, 0.8)",
              "&:hover": {
                borderColor: "rgba(125, 85, 136, 0.8)",
                color: "rgba(125, 85, 136, 0.8)",
                //backgroundColor: "rgba(114, 0, 142, 0.22)",
              },
            }}
          >
            Accedi
          </Button>
        </form>
      </Box>
    );
  }

  return <CustomizedAccordions folder="secretstuff" />;
}

export default SecretStuff;

